import api from "../../api";
import BaseService from "../../base-service";

export default class Service extends BaseService {
  constructor() {
    super();
    this.url = "/api/Users";
  }
  searchByUsernamePassword(username, password) {
    console.log(`${this.url}/filterByUserNamePassword/${username}/${password}`)
    return api
      .get(`${this.url}/filterByUserNamePassword/${username}/${password}`)
      .then(res => res.data);
  }
  update(element) {
    if (element.id) {
      return api.put(`${this.url}/filter/${element.id}`, element)
    } else {
      return api.post(`${this.url}`, element)
    }
  }

  updateRelation(element, relation) {
    if (element.id) {
      return api.put(`${this.url}/filter/${element.id}/${relation}`, element);
    }
  }

  updateRelationRecursive(element, relation) {
    if (element.id) {
      return api.put(
        `${this.url}/filterByRecursive/${element.id}/${relation}`,
        element
      );
    }
  }

  getTree() {
    return api.get(`${this.url}/filterByTree`).then(
      (res) => res.data,
      (err) => {
        console.log(err);
        throw new Error(err.message);
      }
    );
  }

  getStep() {
    return api.get(`${this.url}/filterStep`).then((res) => res.data);
  }

  updateStep(step) {
    return api
      .put(`${this.url}/updateStep?step=${step}`)
      .then((res) => res.data);
  }
}
